var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _path21, _g4, _g5, _g6, _g7, _g8, _g9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 486,
    viewBox: "0 0 315 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.721 116.519L111.221 136.019C111.221 136.019 109.721 133.519 104.721 131.519C99.7212 129.519 81.7212 126.019 81.7212 126.019L63.2212 98.519C63.2212 98.519 69.7212 87.019 67.2212 76.519C64.7212 66.019 53.2212 64.519 53.2212 64.519L38.2212 37.019C38.2212 37.019 48.7212 36.519 56.7212 33.019C64.7212 29.519 74.2212 21.519 74.2212 21.519C74.2212 21.519 75.7212 51.519 91.2212 76.519C106.721 101.519 119.721 116.519 119.721 116.519Z",
    fill: "url(#paint0_linear_1124_48682)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2212 76.519C64.7212 66.019 53.2212 64.519 53.2212 64.519L20.2212 56.019C20.2212 56.019 23.7212 66.019 22.2212 70.519C20.7212 75.019 17.2212 82.519 17.2212 82.519L63.2212 98.519C63.2212 98.519 69.7212 87.019 67.2212 76.519Z",
    fill: "url(#paint1_linear_1124_48682)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2213 70.5192C23.7213 66.0192 20.2213 56.0192 20.2213 56.0192C11.2214 50.019 2.72137 58.019 0.221369 72.519C-2.27863 87.019 17.2213 82.5192 17.2213 82.5192C17.2213 82.5192 20.7213 75.0192 22.2213 70.5192Z",
    fill: "url(#paint2_linear_1124_48682)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7211 33.0191C64.7211 29.5191 74.2211 21.5191 74.2211 21.5191C74.2211 21.5191 64.2211 12.0191 53.2211 12.5191C42.2211 13.0191 40.2212 19.0191 38.2212 22.519C36.2212 26.019 38.2211 37.0191 38.2211 37.0191C38.2211 37.0191 48.7211 36.5191 56.7211 33.0191Z",
    fill: "url(#paint3_linear_1124_48682)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 132L114 139L108.5 184.5L107.5 202.5L127.5 211.5L135.5 198.5C135.5 198.5 126.5 168 126 158C125.5 148 127.5 117.5 129 114.5C130.5 111.5 136.5 113.5 142 104.5C147.5 95.5001 138.5 89.5001 138.5 89.5001L142 81.5001C142 81.5001 137 76.5001 139 72.5001C136 78.5001 132 78.5001 132 78.5001C132 78.5001 130 69 131 63.0001C132 57.0001 135.5 49.5 137 46.5C138.5 43.5 140.5 41.4999 140 38C139.5 34.5001 138.5 30.5001 131 28.5001C123.5 26.5001 119.5 36.5001 119.5 36.5001C119.5 36.5001 114.5 49.0001 114 63.0001C113.5 77.0001 117 88.0001 117 94.0001V111C117 116 108.5 132 108.5 132Z",
    fill: "url(#paint4_linear_1124_48682)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140 38C139.5 34.5001 138.5 30.5001 131 28.5001C126.279 27.2412 122.945 30.7366 121.122 33.5C121.122 33.5 122.5 39.5 127 42.5C131.5 45.5 139.22 42.5 139.22 42.5C139.863 41.1686 140.254 39.7778 140 38Z",
    fill: "url(#paint5_linear_1124_48682)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 162C49.5 166 71.5 165.5 78.5 164.5C85.5 163.5 99.5 162 106 154.5C112.5 147 114.5 139 114.5 139C114.5 139 121.5 151 120 162C118.5 173 117 189 117 189L37 205.5C37 205.5 19.5001 185 21.0001 173C22.5001 161 26 147.5 26 147.5C26 147.5 31.5 158 40.5 162Z",
    fill: "url(#paint6_linear_1124_48682)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 162C49.5 166 71.5 165.5 78.5 164.5C85.5 163.5 99.5 162 106 154.5C112.5 147 114.5 139 114.5 139C114.5 139 109 130.5 101.5 127.5C94 124.5 77.5 121 67 121.5C56.5 122 38.5 130.5 33 134C27.5 137.5 26 147.5 26 147.5C26 147.5 31.5 158 40.5 162Z",
    fill: "url(#paint7_linear_1124_48682)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 162C49.5 166 71.5 165.5 78.5 164.5C85.5 163.5 99.5 162 106 154.5C112.5 147 114.5 139 114.5 139C114.5 139 109 130.5 101.5 127.5C94 124.5 77.5 121 67 121.5C56.5 122 38.5 130.5 33 134C27.5 137.5 26 147.5 26 147.5C26 147.5 31.5 158 40.5 162Z",
    fill: "url(#paint8_radial_1124_48682)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M301.5 357.5C302 376.5 310.5 435.5 289 459.5C267.5 483.5 144 457 121 448C98 439 66.9999 403 52.4999 381C37.9999 359 31 321 47 287.5C63 254 110 234 110 234C110 234 137 252 159 247C181 242 193.5 225 193.5 225H217C224.615 237.887 218 245 236.5 258C255 271 280 265.5 280 265.5C280 265.5 301 338.5 301.5 357.5Z",
    fill: "url(#paint9_linear_1124_48682)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157 15.5C155 40.5 159 62.5 159 62.5L138.5 74C138.5 74 136 64.5 137 57C138 49.5 138.5 44.5 138.5 44.5C138.5 44.5 140 42 140 39C140 36 138.5 32 138.5 32L140.5 9.5C140.5 9.5 147 16 157 15.5Z",
    fill: "url(#paint10_linear_1124_48682)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 9.50021C140.5 9.50021 147 16.0002 157 15.5002C157 15.5002 160.5 14.4998 161.5 12C162.5 9.50021 160 4.50012 156 3.00021C152 1.5003 148.5 0.000209868 142 1.50021C135.5 3.00021 140.5 9.50021 140.5 9.50021Z",
    fill: "url(#paint11_linear_1124_48682)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 112L264 115.5C264 115.5 290 123 293 130.5C296 138 291.5 148.5 287 150C282.5 151.5 277.172 157.093 274 160.5L220.5 180.5C220.5 180.5 175.5 177 170 177.5C164.5 178 159.159 176 159.159 176C159.081 164.953 159 150.465 159 138C159 138 171 124 186 118C201 112 228.5 112 228.5 112Z",
    fill: "url(#paint12_linear_1124_48682)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141 81.5C137.5 78.5 138 73 138 73C138 73 139 65 145 62.4999C151 59.9998 155 58.9999 159 61.9999C163 64.9999 165 73.9998 159.5 79.4998C154 84.9998 144.5 84.5 141 81.5Z",
    fill: "url(#paint13_linear_1124_48682)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141 81.5C137.5 78.5 138 73 138 73C138 73 139 65 145 62.4999C151 59.9998 155 58.9999 159 61.9999C163 64.9999 165 73.9998 159.5 79.4998C154 84.9998 144.5 84.5 141 81.5Z",
    fill: "url(#paint14_radial_1124_48682)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 258C255 271 280 265.5 280 265.5C280 265.5 298 229 292.5 219C287 209 291 186.5 276 186C261 185.5 262.5 202 253 198.5C243.5 195 234 190.5 229 195C224 199.5 234 209 229 214C224 219 217 225 217 225C224.615 237.887 218 245 236.5 258Z",
    fill: "url(#paint15_linear_1124_48682)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 258C255 271 280 265.5 280 265.5C280 265.5 298 229 292.5 219C287 209 291 186.5 276 186C261 185.5 262.5 202 253 198.5C243.5 195 234 190.5 229 195C224 199.5 234 209 229 214C224 219 217 225 217 225C224.615 237.887 218 245 236.5 258Z",
    fill: "url(#paint16_radial_1124_48682)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M229 214C224 219 217 225 217 225C217 225 224 206.5 221.5 200.5C219 194.5 218.5 184 219.5 180C220.5 176 219.5 169 217 167.5C214.5 166 210 146.5 232.5 146.5C255 146.5 268.5 153.5 273.5 160.5C278.5 167.5 284.5 176.5 282 179C279.5 181.5 276 186 276 186C261 185.5 262.5 202 253 198.5C243.5 195 234 190.5 229 195C224 199.5 234 209 229 214Z",
    fill: "url(#paint17_linear_1124_48682)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 200.5C224 206.5 217 225 217 225H125.5C125.5 225 94.5 174.5 91 167C87.5 159.5 89.5 159.5 89.5 159.5C89.5 159.5 137.5 176.5 160 176C182.5 175.5 219.5 180 219.5 180C218.5 184 219 194.5 221.5 200.5Z",
    fill: "url(#paint18_linear_1124_48682)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 201.601C135.834 197.632 140.876 194.495 148.5 193.5C152.4 192.992 156.013 193.044 159.302 193.5C159.302 193.5 159 162 159 138C159 114 165.5 105.5 176 96.5C186.5 87.5 198.5 87 209.5 89.5C220.5 92 228.5 112 228.5 112L264 115.5L251 89.5C251 89.5 235 64 220.5 57.4999C206 50.9999 188.5 51.5 180.5 52.5C172.5 53.5 159 62.5 159 62.5C159 62.5 167 72 159 79.5C151 87 141 81.5 141 81.5C141 81.5 137 85 134 92.5C131 100 128.5 115.5 128.5 115.5C127.5 122 126.5 137.5 126 154.5C125.5 171.5 132.5 201.601 132.5 201.601Z",
    fill: "url(#paint19_linear_1124_48682)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4999 332.5C52.9999 298.5 113 269.5 113 269.5C113 269.5 96 288 104.5 342.5C113 397 166 434 166 434C166 434 59.9999 366.5 56.4999 332.5Z",
    fill: "url(#paint20_linear_1124_48682)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289 440C287 461.5 225 462 225 462C225 462 267 451.5 270.5 432C274 412.5 257 364 275.5 344.5C294 325 291 418.5 289 440Z",
    fill: "url(#paint21_linear_1124_48682)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 247C181 242 193.5 225 193.5 225C193.5 225 191 211 180 211C184.5 207.001 171.5 190.5 148.5 193.5C125.5 196.5 126 219 126 225C121.5 225 110 234 110 234C110 234 137 252 159 247Z",
    fill: "url(#paint22_linear_1124_48682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 247C181 242 193.5 225 193.5 225C193.5 225 191 211 180 211C184.5 207.001 171.5 190.5 148.5 193.5C125.5 196.5 126 219 126 225C121.5 225 110 234 110 234C110 234 137 252 159 247Z",
    fill: "url(#paint23_radial_1124_48682)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9998 287.5C62.9998 254 110 234 110 234C110 234 121.5 225 126 225C125.5 217 127.5 210 127.5 210C127.5 210 118.5 204 114.5 199.5C110.5 195 112.5 182 112 178C111.5 174 102 170.5 95.4998 169C88.9996 167.5 93.5 158 86.9998 159.5C80.4997 161 70.5 175.5 56.9998 182.5C43.4997 189.5 38.9998 205.5 30.9998 216.5C22.9998 227.5 38.9998 240.5 34.9998 247C30.9998 253.5 38.9998 265 34.9998 278.5C30.9998 292 39.2594 312 39.2594 312C40.6678 303.763 43.1775 295.503 46.9998 287.5Z",
    fill: "url(#paint24_linear_1124_48682)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4269 183.654C79.6385 182.543 82.9537 175.508 78.1653 176.619C75.7604 177.176 72.7054 180.163 69 183.654C69 183.654 78.1653 184.143 78.1653 193.652C78.1653 203.161 80.9106 209.456 87.1722 211.307C93.4338 213.159 103.01 226.5 103.01 226.5C104.519 225.695 105.927 225.126 106.895 225.126C106.527 219.202 108 214.018 108 214.018C108 214.018 101.37 209.574 98.4234 206.242C95.4767 202.909 96.9504 193.281 96.5819 190.319C96.2134 187.357 89.2153 184.765 84.4269 183.654Z",
    fill: "url(#paint25_linear_1124_48682)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 247C181 242 193.5 225 193.5 225C193.5 225 191 211 180 211C180 211 165 225 152.5 226.5C140 228 126 225 126 225C121.5 225 110 234 110 234C110 234 137 252 159 247Z",
    fill: "url(#paint26_linear_1124_48682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 247C181 242 193.5 225 193.5 225C193.5 225 191 211 180 211C180 211 165 225 152.5 226.5C140 228 126 225 126 225C121.5 225 110 234 110 234C110 234 137 252 159 247Z",
    fill: "url(#paint27_radial_1124_48682)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169 293C170.5 278.5 219.5 266 219.5 266C219.5 266 220.711 293 210.211 293C199.711 293 164 337.5 164 337.5C164 337.5 167.5 307.5 169 293Z",
    fill: "url(#paint28_linear_1124_48682)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter6_f_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.678 323.174C237.39 345.331 200.006 354.5 200.006 354.5C200.006 354.5 199.243 323.174 215.264 323.174C231.286 323.174 231.286 286.5 231.286 286.5C231.286 286.5 241.967 301.017 239.678 323.174Z",
    fill: "url(#paint29_linear_1124_48682)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter7_f_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.5 67.4995C153.5 77.9993 132.5 107 140 129.5C147.5 152 172.5 84.4994 185 77.9998C197.5 71.5002 245 98.5 239 91.4995C233 84.4991 199.5 56.9998 176.5 67.4995Z",
    fill: "url(#paint30_linear_1124_48682)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter8_f_1124_48682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.5 127.5C170.5 138 166 140.5 173.5 163C181 185.5 195.5 149 208 142.5C220.5 136.001 284.5 139.363 278.5 132.362C272.5 125.362 216.5 117 193.5 127.5Z",
    fill: "url(#paint31_linear_1124_48682)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1124_48682",
    x: 28.3525,
    y: 241.5,
    width: 165.647,
    height: 220.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    result: "effect1_foregroundBlur_1124_48682"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1124_48682",
    x: 201,
    y: 317.843,
    width: 113.503,
    height: 168.157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1124_48682"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1124_48682",
    x: 99,
    y: 184.138,
    width: 105.5,
    height: 76.7397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1124_48682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1124_48682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1124_48682",
    x: 58,
    y: 165.5,
    width: 61,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_1124_48682"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1124_48682",
    x: 106,
    y: 206,
    width: 91.5,
    height: 44.8774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1124_48682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1124_48682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1124_48682",
    x: 136,
    y: 238,
    width: 111.542,
    height: 127.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    result: "effect1_foregroundBlur_1124_48682"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1124_48682",
    x: 172,
    y: 258.5,
    width: 96,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    result: "effect1_foregroundBlur_1124_48682"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1124_48682",
    x: 124.453,
    y: 51.1377,
    width: 129.068,
    height: 96.9353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1124_48682"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1124_48682",
    x: 156.161,
    y: 108.537,
    width: 136.734,
    height: 75.708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1124_48682"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1124_48682",
    x1: 82.3009,
    y1: 126.826,
    x2: 27.1534,
    y2: 109.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D207B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513AC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1124_48682",
    x1: 17.7212,
    y1: 63.019,
    x2: 67.7212,
    y2: 98.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4CCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1124_48682",
    x1: 11.2975,
    y1: 54.0095,
    x2: 11.2975,
    y2: 83.1792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4734B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1124_48682",
    x1: 55.7767,
    y1: 12.5,
    x2: 55.7767,
    y2: 37.0191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5964C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1124_48682",
    x1: 125.64,
    y1: 28.2356,
    x2: 125.64,
    y2: 211.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6374D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6C0E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1124_48682",
    x1: 125,
    y1: 27.5,
    x2: 138.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F237D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6371CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1124_48682",
    x1: 112,
    y1: 201,
    x2: 24.8429,
    y2: 208.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8893F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1124_48682",
    x1: 90,
    y1: 165.5,
    x2: 25.8535,
    y2: 164.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1124_48682",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 132) rotate(14.7911) scale(92.0503 30.8072)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E76B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1124_48682",
    x1: 62.5,
    y1: 225.5,
    x2: 284.5,
    y2: 469.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E57E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1124_48682",
    x1: 147.882,
    y1: 9.5,
    x2: 147.882,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6374D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6C0E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1124_48682",
    x1: 143.38,
    y1: 0.188065,
    x2: 154.906,
    y2: 19.5388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F237D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6371CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1124_48682",
    x1: 232,
    y1: 175,
    x2: 173.836,
    y2: 125.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D207B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513AC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1124_48682",
    x1: 160.683,
    y1: 78.5253,
    x2: 140.252,
    y2: 74.9781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53207B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C38B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1124_48682",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.681 64.1761) rotate(126.011) scale(23.5235 6.82084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654086",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1124_48682",
    x1: 287.128,
    y1: 249.423,
    x2: 221.142,
    y2: 238.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53207B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C38B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1124_48682",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.337 199.113) rotate(123.68) scale(80.1736 22.557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654086",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1124_48682",
    x1: 294,
    y1: 146.5,
    x2: 215,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8893F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D3880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1124_48682",
    x1: 155.77,
    y1: 159.5,
    x2: 144,
    y2: 230.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8675E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D217C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1124_48682",
    x1: 205.5,
    y1: 43.5,
    x2: 126,
    y2: 201.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6273CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1124_48682",
    x1: 94.3378,
    y1: 274.5,
    x2: 94.3378,
    y2: 432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5541C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1124_48682",
    x1: 277.558,
    y1: 372,
    x2: 277.558,
    y2: 467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937507,
    stopColor: "#130B42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1124_48682",
    x1: 122.5,
    y1: 215.5,
    x2: 171.495,
    y2: 230.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53207B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C38B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1124_48682",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.5 203.5) rotate(17.7839) scale(55.6597 23.7077)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654086",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1124_48682",
    x1: 45,
    y1: 327,
    x2: -24.1155,
    y2: 282.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D207B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513AC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1124_48682",
    x1: 28,
    y1: 331.5,
    x2: -31.4296,
    y2: 280.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513AC6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.72
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1124_48682",
    x1: 186.5,
    y1: 240,
    x2: 122,
    y2: 215.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53207B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C38B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1124_48682",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190 217) rotate(147.836) scale(57.2931 15.7415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654086",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1124_48682",
    x1: 203.082,
    y1: 273.853,
    x2: 203.082,
    y2: 316.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5541C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1124_48682",
    x1: 226.143,
    y1: 352.433,
    x2: 226.143,
    y2: 287.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5541C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1124_48682",
    x1: 190.75,
    y1: 65.6587,
    x2: 199,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5862BE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1124_48682",
    x1: 218.297,
    y1: 120.021,
    x2: 226.547,
    y2: 164.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5862BE",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.bd3c07f14e6551dc20a1352550f52d0b.svg";
export { ForwardRef as ReactComponent };